export default __webpack_public_path__ + "static/media/warning--snow-tractors--g1.bb82eff0.png";